export type PushInfo = {
  trackName: string;
  averageUserRating: number;
  userRatingCountForCurrentVersion: number;
  artworkUrl512: string;
};

export const getPushAppInfoFromApple = async (): Promise<PushInfo> => {
  const url = `https://api.pushtrainingapp.com/proxy/?url=${encodeURIComponent(
    'http://itunes.apple.com/US/lookup?id=6450863808',
  )}`;
  const response = await fetch(url);
  const responseBody = await response.json();
  return responseBody.results[0];
};
